export enum AdminEnumType {
    SUPER_ADMIN = 'Super Admin',
    ADMIN = 'Admin'
}